import { NAME } from './constants';
import TransportationGrants from './TransportationGrants';
import TransportationGrant from './TransportationGrant';
import reducer from './reducer';

export default {
  NAME,
  TransportationGrants,
  TransportationGrant,
  reducer,
};



// WEBPACK FOOTER //
// ./src/sites/transportationGrants/index.js